export default __webpack_public_path__ + "static/media/resources.dc163b2d.svg";